import { sleekRarityColor } from './rarityColor';

type Props = {
  badgeName: string | null | undefined;
};

/** The rarity tag above a card: the tier name on a tint of its colour (20%
 *  unless the operator sets `chipFillOpacity`). Nothing for a card without a
 *  known tier. */
export function RarityChip({ badgeName }: Props) {
  const color = sleekRarityColor(badgeName);
  if (!badgeName || !color) return null;
  return (
    <span
      data-co-component="SleekRarity"
      className="inline-flex items-center rounded-[7px] border border-solid border-[var(--co-SleekRarity-chipBorder,rgba(255,255,255,0.01))] px-2 py-[3px] text-[12px] font-semibold leading-[16px] text-[var(--co-SleekRarity-chipText,#FFFFFF)]"
      style={{ background: `color-mix(in srgb, ${color} calc(var(--co-SleekRarity-chipFillOpacity, 0.2) * 100%), transparent)` }}
    >
      {badgeName.trim()}
    </span>
  );
}
